import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { BoxProps, theme } from '@dtx-company/shared-components/src'
import { FC, ReactNode, useRef } from 'react'
import { MenuToggle } from '../styles'
import { MobileLeftNav } from './MobileNavMenu'
import { NAV_V2_HEIGHT } from '@dtx-company/true-common/src/constants/layout'
import { RootState } from '@dtx-company/inter-app/src/redux/types'
import { Text } from '@dtx-company/shared-components/src/components/atoms/Text/index'
import { getTopNavDesktopBreakpoint } from '../TopNav.utils'
import { media } from '@app/common/src/theme'
import { setNavLeftMenu } from '@dtx-company/inter-app/src/redux/slices/config-slice'
import { useDispatch, useSelector } from 'react-redux'
import { useIsMounted } from '@dtx-company/true-common/src/hooks/useIsMounted'
import { useTopNavV2 } from '../TopNav.hooks'
import events from '@dtx-company/inter-app/src/event-tracking/events/nav'
import styled from 'styled-components'

export interface NavProps extends BoxProps {
  logo?: ReactNode
  header?: string
  children: ReactNode
  hasScrolled: boolean
  hasScrolledPastTopNav: boolean
  shouldShowPlatformTopNav: boolean
  menuIconColor?: string
}

const MenuToggleWrapper = styled(Box)<{ hideBreakpoint: number }>`
  ${({ hideBreakpoint }) =>
    `${media.custom(hideBreakpoint)} {
        display: none;
      }
  `}
`

export const TopNavV2: FC<NavProps> = ({
  logo,
  header,
  children,
  shouldShowPlatformTopNav,
  hasScrolledPastTopNav,
  ...rest
}: NavProps) => {
  const dispatch = useDispatch()
  const { isLeftMenuOpen } = useSelector((state: RootState) => state.appReducer.configReducer)
  const navRef = useRef<HTMLDivElement | null>(null)
  const isMounted = useIsMounted()
  const { backgroundColor, borderBottom } = useTopNavV2({
    hasScrolledPastTopNav
  })
  const desktopBreakpoint = getTopNavDesktopBreakpoint(shouldShowPlatformTopNav)
  return (
    <>
      <Box display="contents">
        <Box
          ref={navRef}
          width={'100%'}
          alignItems={'center'}
          maxWidth="100vw"
          height={NAV_V2_HEIGHT}
          padding={'0 12px'}
          backgroundColor={backgroundColor}
          borderBottom={borderBottom}
          {...rest}
        >
          {logo}
          {header && (
            <Text
              display={['none', 'none', 'initial']}
              variant={['body/medium', 'body/medium', 'body/medium', 'body/large']}
              color={'primary.flowBlue'}
              fontWeight={[500, 500, 500, 500]}
            >
              {header}
            </Text>
          )}
          {children}
          {isMounted() && (
            <MenuToggleWrapper ml="19px" hideBreakpoint={desktopBreakpoint}>
              <MenuToggle
                isOpen={isLeftMenuOpen}
                toggle={() => {
                  events.Global_Navigation_Clicked_HamburgerMenu()
                  dispatch(setNavLeftMenu({ open: !isLeftMenuOpen }))
                }}
                color={theme.colors.primary.black}
              />
            </MenuToggleWrapper>
          )}
        </Box>
      </Box>
      <MobileLeftNav open={isLeftMenuOpen} />
    </>
  )
}
